import PropTypes from 'prop-types';
import { memo } from 'react';
import { AddToProjectFavoritesWidget, FAVORITES_STYLE } from '../common/addToProjectFavoritesWidget.js';
import * as MapSearchUtils from './MapSearchUtils.js';
import { ProgressBar } from '../common/ProgressBar.js';


export const MapProjectCard = memo(function({project, equityFocus, isMobile}) {
    const equityFocusSelector = equityFocus ? 'equity-focus-card' : 'non-equity-focus-card';
    const matchCallout = project.bestMatching && project.bestMatching > 0 ? " project-match-offer " : "";
    return (
        <div key={`project_${project.id}`} className={'card-container ' + matchCallout}>
            {matchCallout && <span className="project-match-text">Donations to this project are matched!</span>}
            <a href={project.proposalURL} target="_blank" className={'map-project-card ' + equityFocusSelector}>
                <div className="teacher">
                    {project.prefix + ' ' + project.teacherDisplayName}
                    <span className={isMobile ? 'mobile' : ''}>
                        <AddToProjectFavoritesWidget
                            projectId={parseInt(project.id)}
                            isEligibleForFunding={true}
                            initFavStatus={false}
                            userId={parseInt(userId)}
                            favoritesStyle={FAVORITES_STYLE.heart}
                        />
                    </span>
                </div>
                <div className="header">
                    <div>{project.title}</div>
                </div>
                <div className="description">{project.shortdescription}</div>
                <div className="give-section">
                    <ProgressBar project={project}/>
                    <div className="cost-to-complete">
                        <span className="dollar-amount-remaining">${MapSearchUtils.Helpers.roundCostToCompleteForDisplay(project.costToComplete).toLocaleString('en-US')}</span>
                    </div>
                </div>
            </a>
        </div>
    );
});

MapProjectCard.propTypes = {
    project: PropTypes.object.isRequired,
    equityFocus: PropTypes.bool,
    isMobile: PropTypes.bool,
};



